import React, { useState, useEffect, useRef } from 'react';
import Editor from '@monaco-editor/react';

function TwilioSyncView() {
  const [accountSid, setAccountSid] = useState('');
  const [authToken, setAuthToken] = useState('');
  const [serviceSid, setServiceSid] = useState(
    'ISd11e07cebcc00da56b8dc3172eab1a4a'
  );
  const [docSid, setDocSid] = useState(
    'Proctor_Room_PRa5db2045cdeb4f4a9441c3e6070779b4'
  );
  const [editorContent, setEditorContent] = useState('');
  const [error, setError] = useState('');
  const pollingIntervalRef = useRef(null);

  // Helper: Fetch the Sync Document using REST credentials.
  const fetchDoc = async () => {
    try {
      const response = await fetch(
        `https://sync.twilio.com/v1/Services/${serviceSid}/Documents/${docSid}`,
        {
          headers: {
            Authorization: 'Basic ' + btoa(`${accountSid}:${authToken}`),
          },
        }
      );
      if (!response.ok) {
        throw new Error('Failed to load document: ' + response.statusText);
      }
      const data = await response.json();
      // Assume the document's data is stored as a JSON object.
      const formatted = JSON.stringify(data.data, null, 2);
      setEditorContent(formatted);
    } catch (err) {
      setError(err.message);
    }
  };

  // Load the document and start polling for external changes.
  const handleLoadDoc = async () => {
    setError('');
    await fetchDoc();
    /*
    if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current);
    pollingIntervalRef.current = setInterval(fetchDoc, 5000);
*/
  };

  // Update the document via the REST API.
  const handleSave = async () => {
    setError('');
    try {
      const parsedData = JSON.parse(editorContent);
      const body = new URLSearchParams();
      body.append('Data', JSON.stringify(parsedData));

      const response = await fetch(
        `https://sync.twilio.com/v1/Services/${serviceSid}/Documents/${docSid}`,
        {
          method: 'POST',
          headers: {
            Authorization: 'Basic ' + btoa(`${accountSid}:${authToken}`),
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: body.toString(),
        }
      );
      if (!response.ok) {
        throw new Error('Failed to save document: ' + response.statusText);
      }
      // Refresh the document after saving.
      await fetchDoc();
    } catch (err) {
      setError(err.message);
    }
  };

  // Clear polling when the component unmounts.
  useEffect(() => {
    return () => {
      if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current);
    };
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Twilio Sync Doc Editor (REST Credentials)</h1>
      <div>
        <label>
          Account SID:{' '}
          <input
            type="text"
            value={accountSid}
            onChange={(e) => setAccountSid(e.target.value)}
            style={{ width: '400px', margin: '0 10px' }}
            placeholder="Enter your Account SID"
          />
        </label>
      </div>
      <div style={{ marginTop: '10px' }}>
        <label>
          Auth Token:{' '}
          <input
            type="text"
            value={authToken}
            onChange={(e) => setAuthToken(e.target.value)}
            style={{ width: '400px', margin: '0 10px' }}
            placeholder="Enter your Auth Token"
          />
        </label>
      </div>
      <div style={{ marginTop: '10px' }}>
        <label>
          Service SID:{' '}
          <input
            type="text"
            value={serviceSid}
            onChange={(e) => setServiceSid(e.target.value)}
            style={{ width: '400px', margin: '0 10px' }}
            placeholder="Enter your Sync Service SID"
          />
        </label>
      </div>
      <div style={{ marginTop: '10px' }}>
        <label>
          Document SID:{' '}
          <input
            type="text"
            value={docSid}
            onChange={(e) => setDocSid(e.target.value)}
            style={{ width: '400px', margin: '0 10px' }}
            placeholder="Enter your Document SID"
          />
        </label>
      </div>
      <button onClick={handleLoadDoc} style={{ marginTop: '10px' }}>
        Load Document
      </button>
      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>Error: {error}</div>
      )}
      {editorContent && (
        <div style={{ marginTop: '20px' }}>
          <h2>Document Content</h2>
          <Editor
            language="json"
            value={editorContent}
            onChange={(value) => setEditorContent(value)}
            height="300px"
            options={{
              minimap: { enabled: false },
              formatOnPaste: true,
              formatOnType: true,
            }}
          />
          <button onClick={handleSave} style={{ marginTop: '10px' }}>
            Save
          </button>
        </div>
      )}
    </div>
  );
}

export default TwilioSyncView;
